import Grid from '$components/layout/Grid';
import Player from '../util/Player';
import Styled from './styled';

const { Row, Col } = Grid;

export default function MostExpensiveCarsImages() {
  return (
    <Styled className="MostExpensiveCarsImages">
      <h2>
        The five players with <span>the most expensive cars</span>
      </h2>
      <Row>
        <Col xs={0} md={1} />
        <Player
          number={1}
          name="Pierre-Emerick Aubameyang"
          value="1,150,000"
          team="Arsenal"
          car="Ferrari LaFerrari"
        />
        <Player
          number={2}
          name="Heung-Min Son"
          value="1,150,000"
          team="Tottenham Hotspur"
          car="Ferrari LaFerrari"
        />
        <Player number={3} name="Paul Pogba" value="866,000" team="Manchester United" car="McLaren P1" />
        <Player
          number={4}
          name="Roberto Firmino"
          value="360,000"
          team="Liverpool"
          car="Rolls Royce Phantom"
        />
        <Player
          number={5}
          name="Dele Alli"
          value="360,000"
          team="Tottenham Hotspur"
          car="Rolls Royce Phantom"
        />
      </Row>
    </Styled>
  );
}
